import type {DataFormConfiguration} from 'schema/types';

export const usePrizeFormConfiguration = (): DataFormConfiguration => {
  return {
    schemaContainers: {
      winners: 'NoContainer',
    },
    parts: {
      'winner.type': {
        layout: {
          width: '10rem',
        },
      },
      winners: {
        showStructureOperationInTopOfList: true,
      },
      // TODO: Funker ikke for linkedAgent og linkedLitteraty
      //   'winner.agent': {
      //     layout: {
      //       flex: 1,
      //     },
      //   },
      //   'winner.work': {
      //     layout: {
      //       flex: 1,
      //     },
      //   },
    },
  };
};
